import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

// ============================================
// Layout
// 한 화면에 [라벨 — 입력] 행을 가로로 빽빽하게 정렬하는 어드민 폼 레이아웃.
// 두 컬럼 그리드. 각 셀 = FieldRow (라벨 + 입력). 주소처럼 긴 입력은 FieldRowFull.
// ============================================
export const FormWrapper = styled(Box)({
  maxWidth: 900,
  margin: '0 auto',
  display: 'flex',
  flexDirection: 'column',
});

export const FormGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  rowGap: '14px',
  columnGap: '32px',
  background: '#FAFBFC',
  borderRadius: '10px',
  padding: '24px 28px',
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: '1fr 1fr',
  },
}));

// 본문 폼과 라디오/주소 영역 사이를 분리하는 얇은 디바이더 영역.
export const SectionDivider = styled(Box)(({ theme }) => ({
  borderTop: '1px solid #E5E7EB',
  margin: '4px 0',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / -1',
  },
}));

// ============================================
// Field row (모든 입력 행의 표준 골격)
// 좌측: 고정 폭 라벨, 우측: 입력 영역(flex:1).
// 입력 영역 안에 [입력 + 트레일링(버튼/아이콘/텍스트)] 도 인라인으로 배치 가능.
// ============================================
export const FieldRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  minHeight: '40px',
});

export const FieldRowFull = styled(FieldRow)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / -1',
  },
}));

export const FieldRowLabel = styled(Typography)({
  // "광고성 SMS 수신 동의" 가 110px 에서 두 줄로 꺾여 130px + nowrap 로 한 줄 고정
  width: '130px',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  color: '#374151',
  fontSize: '13px',
  fontWeight: 600,
  letterSpacing: '-0.1px',
  lineHeight: 1.3,
});

export const FieldRowControl = styled(Box)({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  '& > *:first-child': {
    flex: 1,
    minWidth: 0,
  },
});

// 출생일 옆 자동 계산 나이.
export const AgeText = styled(Typography)({
  flexShrink: 0,
  color: '#4AB3BC',
  fontWeight: 700,
  fontSize: '14px',
  letterSpacing: '-0.1px',
  minWidth: '40px',
  textAlign: 'right',
});

// ============================================
// Address helpers
// ============================================
export const AddressHelperText = styled(Typography)({
  color: '#A1A1A1',
  margin: '0 14px 0 0',
  fontSize: '11px',
});
